const socket = io.connect('https://socket.bluebird.ac:5000/');

export default socket;
